export const MODULES_GET_MODULES = 'MODULES_GET_MODULES';
export const MODULES_GET_MODULES_ERROR = 'MODULES_GET_MODULES_ERROR';
export const MODULES_GET_MODULE_ANSWER_BEGIN = 'MODULES_GET_MODULE_ANSWER_BEGIN';
export const MODULES_GET_MODULE_ANSWER_SUCCESS = 'MODULES_GET_MODULE_ANSWER_SUCCESS';
export const MODULES_GET_MODULE_ANSWER_FAILURE = 'MODULES_GET_MODULE_ANSWER_FAILURE';
export const MODULES_GET_MODULE_ANSWER_DISMISS_ERROR = 'MODULES_GET_MODULE_ANSWER_DISMISS_ERROR';
export const MODULES_CLEAR_MODULE_ANSWER = 'MODULES_CLEAR_MODULE_ANSWER';
export const MODULES_TOGGLE_LOCK_MODULE_BEGIN = 'MODULES_TOGGLE_LOCK_MODULE_BEGIN';
export const MODULES_TOGGLE_LOCK_MODULE_SUCCESS = 'MODULES_TOGGLE_LOCK_MODULE_SUCCESS';
export const MODULES_TOGGLE_LOCK_MODULE_FAILURE = 'MODULES_TOGGLE_LOCK_MODULE_FAILURE';
export const MODULES_TOGGLE_LOCK_MODULE_DISMISS_ERROR = 'MODULES_TOGGLE_LOCK_MODULE_DISMISS_ERROR';
export const MODULES_UPDATE_NOTES_BEGIN = 'MODULES_UPDATE_NOTES_BEGIN';
export const MODULES_UPDATE_NOTES_SUCCESS = 'MODULES_UPDATE_NOTES_SUCCESS';
export const MODULES_UPDATE_NOTES_FAILURE = 'MODULES_UPDATE_NOTES_FAILURE';
export const MODULES_UPDATE_NOTES_DISMISS_ERROR = 'MODULES_UPDATE_NOTES_DISMISS_ERROR';
export const MODULES_GET_MODULE_PLAYLIST = 'MODULES_GET_MODULE_PLAYLIST';
export const MODULES_GET_MODULE_PLAYLIST_ERROR = 'MODULES_GET_MODULE_PLAYLIST_ERROR';


// WEBPACK FOOTER //
// ./src/features/modules/redux/constants.js